import db from '../../config/databases/forms';
import getFormLocal from './getFormLocal';
import refreshFormsList from './refreshFormsList';

// Remove escape question
export default async function removeValue(formId, question) {
  const _formId = parseInt(formId, 10);
  const form = await getFormLocal(formId);
  delete form.inspection[question];
  await db.table('forms').put(form, _formId);
  refreshFormsList();
}
